module.exports = __webpack_public_path__ + "img/admin-img.b196f9de.png";